module.exports = __webpack_public_path__ + "img/recognition.53d51d02.png";